window.onload = () => {
	// Footer callback block script
	var callbackbuttons = document.getElementsByClassName('c-footer_callback');
	if (callbackbuttons == 'undefined') return;

	for (var i = 0; i < callbackbuttons.length; i++) {
		var callbackbutton = callbackbuttons[i];

		var currentId = callbackbutton.getAttribute('uniqueId');

		// var modal = document.getElementById("c-footer__callback-modal-" + currentId);
		callbackbutton.onclick = function () {
			var currentId = this.getAttribute('uniqueId');
			document.getElementById(
				'c-footer__callback-modal-' + currentId
			).style.display = 'block';
		};

		var span = document.getElementById('callback-close-' + currentId);
		span.onclick = function () {
			var currentId = this.getAttribute('uniqueId');
			document.getElementById(
				'c-footer__callback-modal-' + currentId
			).style.display = 'none';
			document.getElementById(
				'callback_result-' + currentId
			).style.display = 'none';
			document
				.getElementById('c-footer_callbackform-' + currentId)
				.reset();
		};

		// Form submitted
		var callbackform = document.getElementById(
			'c-footer_callbackform-' + currentId
		);
		callbackform.onsubmit = function () {
			var currentId = this.getAttribute('uniqueId');
			document.getElementById(
				'callback_result-' + currentId
			).style.display = 'block';
		};
	}

	window.onclick = function (event) {
		if (event.target.hasAttribute('modalUniqueId')) {
			var currentId = event.target.getAttribute('modalUniqueId');
			document.getElementById(
				'c-footer__callback-modal-' + currentId
			).style.display = 'none';
			document.getElementById(
				'callback_result-' + currentId
			).style.display = 'none';
			document
				.getElementById('c-footer_callbackform-' + currentId)
				.reset();
		}
	};
};
